import React from "react";
// import { Link } from "gatsby";
// import Img from "gatsby-image";

const YunJia = () => {
  return (
    <table width="263" border="0" cellSpacing="0" cellPadding="0" align="center">
        <tbody>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td width="263" height="38" background="/images/left_bj1.gif" style={{paddingLeft:'25px'}}>&nbsp;<span className="STYLE3">航空货运最新运价</span></td>
        </tr>
        <tr>
          <td><table width="100%" border="0" cellSpacing="0" cellPadding="0">
            <tbody><tr>
              <td width="1" bgcolor="#e5e5e9"></td>
              <td width="261">
                <table width="95%" border="0" cellPadding="0" cellSpacing="0" align="center">
                <tbody>
                <tr>
                <td height="25" align="left" width="78%"><img src="/images/jt.gif" width="3" height="5" />&nbsp;<a className="TOP" href="/price">上海东大空运10月最新国内运...</a></td>
                </tr>
                <tr>
                <td colSpan="2" height="1" width="579"></td>
                </tr>
                </tbody>
                </table>
              </td>
              <td width="1" bgcolor="#e5e5e9"></td>
            </tr>
          </tbody></table></td>
        </tr>
        <tr>
          <td width="263" height="1" bgcolor="#e5e5e9"></td>
        </tr>
      </tbody>
      </table>
  );
};

export default YunJia;
